var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBriefcase16(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fillOpacity: 0.15,
    d: "M2 10h12v3.5H2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.25 1.5a1.75 1.75 0 011.744 1.606L11 3.25V4h2a2 2 0 012 2v6.5a2 2 0 01-2 2H3a2 2 0 01-2-2V6a2 2 0 012-2h2v-.75a1.75 1.75 0 011.606-1.744L6.75 1.5h2.5zM13 11H3c-.173 0-.34-.022-.5-.063V12.5a.5.5 0 00.41.492L3 13h10a.5.5 0 00.492-.41l.008-.09.001-1.563c-.16.041-.328.063-.501.063zm0-5.5H3a.5.5 0 00-.492.41L2.5 6v3a.5.5 0 00.41.492L3 9.5h10a.5.5 0 00.492-.41L13.5 9V6a.5.5 0 00-.41-.492L13 5.5zM8 7a.75.75 0 110 1.5A.75.75 0 018 7zm1.25-4h-2.5a.25.25 0 00-.243.193L6.5 3.25V4h3v-.75a.25.25 0 00-.193-.243L9.25 3z",
    fillRule: "nonzero"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBriefcase16);
export default __webpack_public_path__ + "static/media/briefcase-16.820ea63a.svg";
export { ForwardRef as ReactComponent };